import Accordion from 'react-bootstrap/Accordion';
import {  Overlay, Button, Form, Toast, Popover, Dropdown } from 'react-bootstrap';
import { useState, useEffect, useRef } from "react";
import { Breadcrumb } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../App.css';
import HelpButton from "./HelpButton";

/*자택 house*/
function Page3() {
 // const dropdownId = 'dropdown-postbox';
  //const location = useLocation();
  const [toastMessage, setToastMessage] = useState({ text: '', subtext: '', correct: false });
  const [password, setPassword] = useState('');

  const [showDoorPopover, setShowDoorPopover] = useState(false);
  const [DoorPopoverText, setDoorPopoverText] = useState('');
  const DoorRef = useRef(null);

  const handleDoorClick = () => {
  setDoorPopoverText("잠겨있다");
  setShowDoorPopover(true);
  setTimeout(() => setShowDoorPopover(false), 2000);
};

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = password.trim().toLowerCase();
    if (trimmed === 'gch') {
      setToastMessage({
        text: '... 문자로 보낸 주소로 와',
        subtext: '이동하기',
        correct: true
    });
    } else  {
      setToastMessage({
        text: '잘못 거셨습니다',
        subtext: '... 다른 사람에게 연락해 보자',
        correct: false
    });
    }
    setShow(true);
  };

  const [showContactButton, setShowContactButton] = useState(false); // 버튼 표시 여부

  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const goToLink = () => {
    navigate('/mansion'); 
  };

  const location = useLocation();

  useEffect(() => {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    popoverTriggerList.forEach(el => {
      const popoverInstance = Popover.getInstance(el);
      if (popoverInstance) {
        popoverInstance.hide();
        popoverInstance.dispose();
      }
    });

     [...popoverTriggerList].forEach(el => new Popover(el));
  }, [location]);

  return (
    <div className="container mt-4 position-relative" style={{ height: '100vh' }}>
      {/* Breadcrumb */}
      <div className="d-flex justify-content-between align-items-center">
      <Breadcrumb className="mb-0">
        <Breadcrumb.Item
          onClick={(e) => {
            e.preventDefault();  // 링크 기본동작 막기
            alert('아직 일을 마치지 못했다');
          }}
          href="#" // href 있어야 커서 포인터 모양 유지됨
          style={{ cursor: 'pointer' }} // 클릭 가능하다는 시각적 표시
        >
          집
        </Breadcrumb.Item>

        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/office' }}>
          사무실
        </Breadcrumb.Item>
        <Breadcrumb.Item active>길드장님 자택</Breadcrumb.Item>
      </Breadcrumb>

      {/* 오른쪽 상단 버튼 */}
        <HelpButton />
        </div>

      {/* 수평선 */}
      <hr className="border border-dark-subtle border-2 opacity-100" />

      {/* 설명 */}
      <div className="text-start">
        <p>조용하다</p>
      </div>

        <div
      className="d-flex justify-content-center align-content-center flex-wrap" 
        style={{height: 'calc(100vh - 200px)',
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'center',
        gap: '13px',
        marginTop: '-10vh',
         }}>
        <button
          ref={DoorRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleDoorClick}
          style={{
            width: '28vw',
            height: '40vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >현관문</button>

          <Dropdown>          
          <Dropdown.Toggle
          className="btn btn-secondary"
          //type="button"
          id='dropdownMenuButton'          
          //data-bs-toggle="dropdown"
          //aria-expanded="false"
          style={{
            width: '9vw',
            height: '15wh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '60%',
          }}
          >우편함</Dropdown.Toggle>

            <Dropdown.Menu 
            style={{ 
              width:'25vw', 
              maxHeight: '30vh', 
              overflowY:'auto', 
              fontSize:'80%',}}
              onClick={(e) => e.stopPropagation()}
              >
              <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <span style={{fontSize:'80%'}} className="fst-italic">헌터협회</span>
                  </Accordion.Header>
                <Accordion.Body>
                  <span className="fst-italic" style={{color: 'gray'}}>
                    [던전 공략 1,000회 달성에 감사드리며 앞으로도...]
                  </span> <br></br>
                  ... 종이가 눅눅하다. 던전이라...
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <span style={{fontSize:'80%'}} className="fst-italic">국세청</span>
                </Accordion.Header>
                <Accordion.Body>
                  <span className="fst-italic" style={{color: 'gray'}}>
                    [어려운 여건 속에서도 나라 발전을 위하여 많은 세금을 납부하여 주신 데 대하여 깊은 감사의 말씀...]
                  </span> <br></br>
                  ... 종이가 축축하다. 보기보다 성실히 세금을 내시는 듯 하다
                </Accordion.Body>
              </Accordion.Item>
               <Accordion.Item eventKey="2">
                <Accordion.Header onClick={() => setShowContactButton(true)}>
                  <span style={{fontSize:'80%'}} className="fst-italic">???</span>
                </Accordion.Header>
                <Accordion.Body>
                  <span className="fst-italic" style={{color: 'gray'}}>
                    [중요한 일은 이쪽으로 연락 주세요. <br/> 321478965-3214789-147456369]
                  </span> <br></br>
                  ... 길드장님이 남기신 것 같다
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Dropdown.Menu>
          </Dropdown>
        </div>

        {showContactButton && (
    <>
    {/* 버튼만 */}
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 999
    }}>
      <button type="button" className="btn btn-outline-primary" size="sm" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
        누구에게 연락하지?
      </button>
    </div>
    </>
        )}

    {/* ✅ 버튼 외부에 둬야 전체화면 */}
    <div className="offcanvas offcanvas-start" 
      tabIndex="-1" 
      id="offcanvasExample" 
      aria-labelledby="offcanvasExampleLabel"
      style={{
        width: '70vw',
        maxWidth: '70vw',
        height: '100vh'
      }}
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="offcanvasExampleLabel">누구에게 연락하지?</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formPassword">
          <Form.Label>이름을 입력하세요</Form.Label>
          <Form.Control
            type="text"
            placeholder="_ _ _"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>

        <div className="d-flex gap-2 mb-2 justify-content-end">
        <Button
              variant="outline-secondary"
              className="mt-3"
              onClick={() => {alert('휴대폰 전화 키패드에 입력해볼까?');}}
            >
              HINT
        </Button>
        <Button variant="primary" type="submit" className="mt-3">
          확인
        </Button>
          </div>
        </Form>
      </div>
    </div>
      
      <div aria-live="polite" aria-atomic="true" className='position-relative'>
        <div className='toast-container top-0 end-0 p-3'
          style={{ transform: 'translateY(-15vh)' }}
        >
        <Toast
          show={show}
          onClose={() => setShow(false)}
          autohide={!toastMessage.correct} 
          delay={toastMessage.correct ? 0 : 2500} // 정답일 땐 자동 닫힘 방지
          bg={toastMessage.correct ? 'success' : 'danger'}
          style={{
            position: 'absolute',
            top:0,
            right:0,
            zIndex: 9999,
            minWidth: '240px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}
        >
          <div className='toast-header'>
            <strong className="me-auto"></strong>
            <small className="text-muted">Just now</small>
            <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" />
            </div>
          
          <div className="toast-body" style={{
            backgroundColor: 'white',
            color: toastMessage.correct ? 'black' : 'black',
          }}>
              <span style={{ color: 'gray', fontStyle: 'italic' }}>
              {toastMessage.text}
              </span>
              <div style={{ marginTop: '6px', display: 'flex', justifyContent: 'flex-end' }}>
                {toastMessage.correct ? (
                  <Button variant="outline-primary" size="sm" onClick={goToLink}>
                    {toastMessage.subtext}
                  </Button>
                ) : (
                  <span>{toastMessage.subtext}</span>
                )}



            </div>
            </div>
          </Toast>
        </div>
      </div>

                
      {DoorRef.current && (
        <Overlay target={DoorRef.current} show={showDoorPopover} placement="top">
          {(props) => (
            <Popover {...props}>
              <Popover.Body>{DoorPopoverText}</Popover.Body>
            </Popover>
          )}
        </Overlay>
      )}

    </div>

  );
}

export default Page3;